import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { SyncService } from 'src/app/sync.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NotificationType } from 'carbon-components-angular/notification/notification-content.interface';


@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
	authStatus = 'unauthenticated';

	email = '';
	emailInvalid = false;
	emailInvalidText = '';

	password = '';
	confirmPassword = '';
	passwordInvalid = false;
	confirmPasswordInvalid = false;
	passwordInvalidText = '';
	confirmPasswordInvalidText = '';

	subscription: any;
	showNotification: any;
	notificationType: NotificationType = 'success';
	notificationTitle = '';
	workspace = '';

	constructor(
		private syncService: SyncService,
		private afAuth: AngularFireAuth,
		private afStore: AngularFirestore,
		private http: HttpClient
	) {}

	navigateToPage(path: string) {
		this.syncService.updatePage(path);
	}

	ngOnInit(): void {
		this.syncService.authStatus$.subscribe((data) => {
			this.authStatus = data;
		});
		this.syncService.email$.subscribe((data) => {
			this.email = data;
		});
	}

	onKeyUpEmail($event: KeyboardEvent) {
		this.email = ($event.target as HTMLInputElement).value;
		this.syncService.updateEmail(this.email);
	}

	validateEmail() {
		this.emailInvalid = false;
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (this.email.trim() === '') {
			this.emailInvalid = true;
			this.emailInvalidText = 'Email cannot be empty';
		} else if (!emailRegex.test(this.email)) {
			this.emailInvalid = true;
			this.emailInvalidText = 'Invalid email format';
		}
	}

	onKeyUpPassword($event: KeyboardEvent) {
		this.password = ($event.target as HTMLInputElement).value;
		this.syncService.updatePassword(this.password);
	}

	onKeyUpConfirmPassword($event: KeyboardEvent) {
		this.confirmPassword = ($event.target as HTMLInputElement).value;
		this.syncService.updatePassword(this.password);
	}

	validatePassword() {
		this.passwordInvalid = false;
		this.confirmPasswordInvalid = false;
		if (this.password.length < 8) {
			this.passwordInvalid = true;
			this.passwordInvalidText = 'Must be 8+ characters';
		} else if (this.password.trim() === '') {
			this.passwordInvalid = true;
			this.passwordInvalidText = 'Password cannot be empty';
		}
		if (this.password !== this.confirmPassword) {
			this.confirmPasswordInvalid = true;
			this.confirmPasswordInvalidText = 'Passwords do not match';
		}
	}

	async signUp() {
		this.validateEmail();
		this.validatePassword();
		if (this.emailInvalid || this.passwordInvalid || this.confirmPasswordInvalid) {
			return;
		}
		this.updateAuthStatus('authenticating');
		this.afAuth.createUserWithEmailAndPassword(this.email, this.password).then(async () => {
			if (this.email.endsWith('multiplai.co')) {
				this.workspace = 'MultiplAI';
			} else if (this.email.endsWith('multiplai-test.co')) {
				this.workspace = 'MultiplAI Test';
			} else if (this.email.endsWith('multiplai-demo.co')) {
				this.workspace = 'MultiplAI Demo';
			} else if (this.email.endsWith('seinecap.com')) {
				this.workspace = 'Seine Capital';
			} else if (this.email.endsWith('industryventures.com')) {
				this.workspace = 'Industry Ventures'
			} else {
				this.emailInvalid = true;
				this.emailInvalidText = 'Your organization is not supported.';
				this.updateAuthStatus('unauthenticated');
				if (this.subscription) {
					this.subscription.unsubscribe();
				}
				return;
			}
			this.syncService.updateWorkspace(this.workspace);
			this.syncService.updatePage('login');

			const snapshot = await this.afStore.collection(
				'Users', ref => ref.where('Workspace', '==', this.workspace),
			).snapshotChanges();
			this.subscription = snapshot.subscribe(docs => {
				if (docs.length === 0) {
					this.syncService.updateUserId(null);
					this.syncService.updateUserData(null);
					return;
				} else {
					const userDoc = docs[0].payload.doc;
					const userData = userDoc.data();
					// @ts-ignore
					userData['Email'] = this.email; // DONE
					this.syncService.updateUserId(userDoc.id);
					this.syncService.updateUserData(userData);
					this.syncService.updateCurrentDeal('');
					// @ts-ignore
					console.log(userData['Current File']);
					// @ts-ignore
					if (userData['Current File']) {
						// @ts-ignore
						this.syncService.updateFileId(userData['Current File']);
					}
					// @ts-ignore
					this.updateAuthStatus('authenticated');
					if (this.subscription) {
						this.subscription.unsubscribe();
					}
					// @ts-ignore
					this.syncService.updatePage('funds');
				}
			});

		}).catch((response: any) => {
			this.emailInvalid = true;
			this.emailInvalidText = 'Email address in use by another account';
			this.updateAuthStatus('unauthenticated');
			if (this.subscription) {
				this.subscription.unsubscribe();
			}
		});
		const formData: FormData = new FormData();
		formData.append('Field', '000-Asset Name');
		formData.append('Value', 'Crescent Asia');
		formData.append('Page URL', 'https://firebasestorage.googleapis.com/v0/b/multiplai-test.appspot.com/o/demo%40multiplai.co__HW%20Nov%2019__Kallang%20%3E%202022-12-31_2022%20Q4%20Quarterly%20Portfolio%20Report.pdf__Page%200?alt=media');
		// @ts-ignore
		formData.append('Polygons Document', 'Zf9ueWTLW0At49IQrHnK');
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'multipart/form-data');
		this.http.post(environment.polygonUrl, formData, { headers, responseType: 'json' });
	}

	updateAuthStatus(status: string) {
		this.authStatus = status;
		this.syncService.updateAuthStatus(status);
	}
}
